import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "./baseQuery";
import { groupsApi } from "./groupsApi";
import { managementApi } from "./managementApi";

export const authApi = createApi({
  reducerPath: "panelAuth",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Me"],
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (body) => ({ url: "/api/panel/auth/login", method: "POST", data: body }),
    }),
    signup: builder.mutation({
      query: (body) => ({ url: "/api/panel/auth/signup", method: "POST", data: body }),
    }),
    sendVerificationCode: builder.mutation({
      query: (body) => ({ url: "/api/panel/auth/send-verification-code", method: "POST", data: body }),
    }),
    verifyEmailCode: builder.mutation({
      query: (body) => ({ url: "/api/panel/auth/verify-email-code", method: "POST", data: body }),
    }),
    forgotPassword: builder.mutation({
      query: (body) => ({ url: "/api/panel/auth/forgot-password", method: "POST", data: body }),
    }),
    getMe: builder.query({
      query: () => ({ url: "/api/panel/auth/me", method: "POST", data: {} }),
      providesTags: ["Me"],
    }),
    // Profil resmi: kazanılmış bir ünvan kodu ("istikrar.3"); code yoksa
    // baş harflere döner. Başarıda oturumdaki kullanıcı (getMe) yerinde
    // güncellenir, grup listelerindeki kendi satırı için önbellek tazelenir.
    setAvatarTitle: builder.mutation({
      query: ({ code } = {}) => ({
        url: "/api/users/set-avatar-title",
        method: "POST",
        data: code ? { code } : {},
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          const avatar = data?.data?.avatar || null;
          dispatch(
            authApi.util.updateQueryData("getMe", undefined, (draft) => {
              if (!draft?.data) return;
              if (draft.data.user) draft.data.user.avatarTitle = avatar ? avatar.code : null;
              draft.data.avatar = avatar;
            })
          );
          dispatch(groupsApi.util.invalidateTags(["GroupProgress", "GroupFeed", "GroupMember"]));
          dispatch(managementApi.util.invalidateTags(["ManagedGroups", "ManagedGroup", "GroupStats"]));
        } catch {
          // Hata bileşende gösterilir.
        }
      },
    }),
    logout: builder.mutation({
      query: () => ({ url: "/api/panel/auth/logout", method: "POST", data: {} }),
    }),
  }),
});

export const {
  useLoginMutation,
  useSignupMutation,
  useSendVerificationCodeMutation,
  useVerifyEmailCodeMutation,
  useForgotPasswordMutation,
  useGetMeQuery,
  useLazyGetMeQuery,
  useLogoutMutation,
  useSetAvatarTitleMutation,
} = authApi;
